import { Box, Card, CardContent, SxProps, Theme } from '@mui/material';
import React from 'react';

interface VideoCardProps {
  videoUrl: string | null;
  sx?: SxProps<Theme>;
}

const VideoSliderItem: React.FC<VideoCardProps> = ({ videoUrl, sx }) => {
  return (
    <Card sx={sx} className="video-slider-card">
      <CardContent sx={{ margin: '0', padding: '0', paddingBottom: '2.5rem !important' }}>
        <Box className="responsive-video">
          {videoUrl !== null && (
            <iframe title="vimeo-player" src={videoUrl} allowFullScreen></iframe>
          )}
        </Box>
      </CardContent>
    </Card>
  );
};

export default VideoSliderItem;
